import { env } from '../config';
import type { AvailableLocale } from '../types/AvailableLocales';

export interface Features {
    available_locales: AvailableLocale[];
    default_locale: AvailableLocale;
    performance_test: boolean;
    password_change_url: string | null;
    sentry_frontend_dsn: string | null;
    oidc: boolean;
    instance_footer: string | null;
    partial_points_enabled: boolean;
    more_than_max_points_enabled: boolean;
    custom_logos: {
        color: boolean;
        white: boolean;
    };
}

export const defaultFeaturesValue: Features = {
    available_locales: [],
    default_locale: undefined,
    performance_test: false,
    password_change_url: null,
    sentry_frontend_dsn: null,
    oidc: false,
    instance_footer: null,
    partial_points_enabled: true,
    more_than_max_points_enabled: true,
    custom_logos: {
        color: false,
        white: false,
    },
};

/**
 * Get available instance features from the feature REST API.
 */
export async function getFeatures(): Promise<Features> {
    const response = await fetch(
        `${env.VITE_API_BASE_URL}${env.VITE_FEATURES_API_ENDPOINT}`,
    );

    const features = (await response.json()) as Features;

    if (!features) {
        return defaultFeaturesValue;
    }

    return { ...defaultFeaturesValue, ...features };
}
